export var OcvInAppFeedback = 'ocv-inapp-feedback';
export var CentroDataSourcesString = 'centro.hvc.feedback.initOptions';
export var CentroUrlProd = 'https://admin.microsoft.com';
export var PerfPrefix = 'OcvFeedback';
export var TelemetryPrefix = 'logInAppFeedback';
export var TelemetryIdInfo = '523909';
export var TelemetryIdError = '523910';
export var DefaultMajorVersion = 'v2';
export var guidRegexPattern = /^$|^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
